<template>
  <div class="pb-6 flex flex-col gap-4">
    <ChatGPTEditorFormRowFull :item="PROMPT"
                              :is-item-error="false"
                              :row-count="20"
                              :token-count="promptTokenCount"
                              :is-disabled="true"
                              :action="action"
    />
    <ChatGPTEditorFormRowFull :item="USER_PROMPT"
                              :is-item-error="false"
                              :row-count="10"
                              :token-count="userPromptTokenCount"
                              :is-disabled="true"
                              :action="action"
    />
    <ChatGPTEditorFormRowFull v-if="action.type === ACTION_TYPES.CHAT_GPT_CUSTOM"
                              :item="SEARCH_METADATA"
                              :is-item-error="false"
                              :row-count="4"
                              :token-count="searchMetadataTokenCount"
                              :is-disabled="true"
                              :action="action"
    />

    <div class="grid grid-cols-2 gap-2">
      <div class="col-span-1">
        <BaseLabel :id="MAX_TOKENS.id"
                   :label="MAX_TOKENS.label"
                   :tooltip="MAX_TOKENS.tooltip"
                   tooltip-position="top"
        />
        <span class="mt-3">
          {{ maxTokens }} tokens
        </span>
      </div>

      <div class="col-span-1">
        <BaseLabel id="tokenCount"
                   label="Token count"
                   tooltip="System prompt tokens +<br/>User prompt tokens +<br/>Search metadata tokens<br/><b>= Token count</b>"
                   tooltip-position="top"
        />
        <span class="mt-3">
          {{ totalTokenCount }} tokens
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import ChatGPTEditorFormRowFull from '@/components/editor/ChatGPTEditorFormRowFull'
import { ACTION_TYPES } from '@/utils/bot-json.constants'
import { CHAT_GPT_EDITOR_PROPS } from '@/constants/chat-gpt.constants'
import $script from 'scriptjs'

const {
  PROMPT,
  USER_PROMPT,
  SEARCH_METADATA,
  MAX_TOKENS
} = CHAT_GPT_EDITOR_PROPS

export default {
  name: 'ChatGPTActionDetailPrompt',

  components: { ChatGPTEditorFormRowFull },

  props: {
    action: {
      type: Object,
      required: true
    },
    formData: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      tokenizer: null,
      ACTION_TYPES,
      PROMPT,
      USER_PROMPT,
      SEARCH_METADATA,
      MAX_TOKENS
    }
  },

  computed: {
    promptTokenCount() {
      if (!this.action?.prompt.length) return 0

      return this.tokenizer?.encode(this.action.prompt).length || 0
    },

    userPromptTokenCount() {
      if (!this.action?.userPrompt?.length) return 0

      return this.tokenizer?.encode(this.action.userPrompt).length || 0
    },

    searchMetadataTokenCount() {
      if (!this.action?.searchMetadata?.length) return 0

      return this.tokenizer?.encode(this.action.searchMetadata).length || 0
    },

    totalTokenCount() {
      return this.promptTokenCount + this.userPromptTokenCount + this.searchMetadataTokenCount
    },
    
    maxTokens() {
      return this.action.maxTokens
    }
  },

  methods: {
    async initTokenizer() {
      if (!window.GPTTokenizer_cl100k_base) {
        await new Promise(resolve => $script('https://unpkg.com/gpt-tokenizer', resolve))
      }
      this.tokenizer = window.GPTTokenizer_cl100k_base
    }
  },

  async mounted() {
    await this.initTokenizer()
  }
}
</script>
